import React from "react";
import "./ServiceDetails.css";

import { TbMessageChatbotFilled } from "react-icons/tb";
import { BsCloudFogFill } from "react-icons/bs";
import { BiLineChart } from "react-icons/bi";
import { MdChecklist } from "react-icons/md";
import { useParams } from "react-router-dom";

import AIChatButton from "../../../components/AIChatButton/AIChatButton";

const allRecords = {
  "ai-voice-assistant-ai-agent": [
    {
      icon: <TbMessageChatbotFilled className="custom-icon" />,
      title: "AI-Powered Chatbot",
      description:
        "Empower customer engagement with our seamless AI chatbot, delivering personalized experiences and instant support for enhanced user satisfaction and conversions.",
    },
    {
      icon: <BsCloudFogFill className="custom-icon" />,
      title: "AI SaaS-Based Applications",
      description:
        "Experience the power of our AI-based SaaS applications, designed to streamline your business operations, boost productivity, and adapt seamlessly to your evolving needs.",
    },
    {
      icon: <BiLineChart className="custom-icon" />,
      title: "Custom Solutions for Your Business",
      description:
        "Experience the power of our AI-based SaaS applications, designed to streamline your business operations, boost productivity, and adapt seamlessly to your evolving needs.",
    },
    {
      icon: <MdChecklist className="custom-icon" />,
      title: "Automate Workflows",
      description:
        "Streamline your business operations with AI-powered automation. Reduce manual tasks and enhance productivity by integrating smart workflows that work seamlessly across your systems.",
    },
  ],
  "web-development": [
    {
      icon: <TbMessageChatbotFilled className="custom-icon" />,
      title: "Responsive Web Apps",
      description:
        "Deliver seamless user experiences with cutting-edge, responsive sites.",
    },
    {
      icon: <BsCloudFogFill className="custom-icon" />,
      title: "Modern Tech Stack",
      description:
        "Leverage the latest frameworks for secure and scalable solutions.",
    },
    {
      icon: <BiLineChart className="custom-icon" />,
      title: "E-Commerce Solutions",
      description:
        "Grow your business with fully integrated and optimized e-commerce sites.",
    },
    {
      icon: <MdChecklist className="custom-icon" />,
      title: "Ongoing Maintenance",
      description:
        "Enjoy peace of mind with continuous updates and 24/7 support.",
    },
  ],
  "mobile-app-development-android-ios-hybrid-apps": [
    {
      icon: <TbMessageChatbotFilled className="custom-icon" />,
      title: "Hybrid Mobile Apps",
      description:
        "Build cross-platform apps that deliver native-like performance.",
    },
    {
      icon: <BsCloudFogFill className="custom-icon" />,
      title: "User-Centric Design",
      description:
        "Focus on intuitive interfaces and seamless user experiences.",
    },
    {
      icon: <BiLineChart className="custom-icon" />,
      title: "Android & iOS Expertise",
      description:
        "Leverage our deep knowledge of both platforms for maximum reach.",
    },
    {
      icon: <MdChecklist className="custom-icon" />,
      title: "Ongoing App Support",
      description:
        "Benefit from continuous improvements and timely feature updates.",
    },
  ],
  "machine-learning-deep-learning-solutions": [
    {
      icon: <TbMessageChatbotFilled className="custom-icon" />,
      title: "Predictive Analytics",
      description:
        "Harness data to forecast trends, improve decision-making, and reduce costs.",
    },
    {
      icon: <BsCloudFogFill className="custom-icon" />,
      title: "Deep Learning Models",
      description:
        "Build sophisticated AI models for image recognition, NLP, and more.",
    },
    {
      icon: <BiLineChart className="custom-icon" />,
      title: "Custom AI Integrations",
      description: "Embed AI into your existing workflows to boost efficiency.",
    },
    {
      icon: <MdChecklist className="custom-icon" />,
      title: "End-to-End ML Pipeline",
      description:
        "From data gathering to deployment, streamline your ML lifecycle.",
    },
  ],
};

export default function ServiceDetails() {
  const { slug } = useParams();
  const services = allRecords[slug] || Object.values(allRecords)[0] || [];

  return (
    <div className="service-details">
      <div className="container-fluid">
        <div className="mb-5 d-flex justify-content-center">
          <AIChatButton />
        </div>

        <h1 className="service-details-title">
          Unlock the Power of AI with Us
        </h1>
        <div className="row">
          <div className="service-cards-grid">
            {services?.map((service, index) => (
              <div className="service-card" key={index}>
                <div className="service-card-icon-container">
                  {service.icon}
                </div>
                <div className="service-card-content">
                  <h3 className="service-card-title">{service.title}</h3>
                  <p className="service-card-description">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
